import { createAppSlice } from '../../app/createAppSlice'

const initialState = {
    tabFocus: "Text View",
    tabMenu: ["Text View", "JSON View", "Usage View"]
};

const tabPaneSlice = createAppSlice({
    name: "tabPane",
    initialState,
    reducers: create => ({
        changeTabFocus: create.reducer((state, action) => {
            state.tabFocus = action.payload
        }),
        changeTabMenu: create.reducer((state, action) => {
            state.tabMenu = action.payload
        }),
    }),
    selectors: {
        selectTabFocus: tabPane => tabPane.tabFocus,
        selectTabMenu: tabPane => tabPane.tabMenu
    },
})

export const { changeTabFocus, changeTabMenu } = tabPaneSlice.actions

export const { selectTabFocus, selectTabMenu } = tabPaneSlice.selectors

export default tabPaneSlice